export default __webpack_public_path__ + "4e4aa5fd34b4586cb63b532c8460a9ec.png";